/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { usePopupManager } from '../../providers/PopupManager/PopupManager';
import { MESSAGE_TYPE } from '../../constants';
import axios from "axios";
import Select from 'react-select';
import config from '../../config/config';
import DomainTile from '../DomainTile/DomainTile';
import TransBarChart from './TransBarChart/TransBarChart';
import FTEWiseChart from './FTEWiseChart/FTEWiseChart';
import QuerterwiseChart from './QuerterwiseChart/QuerterwiseChart';
import TowerFTEChart from './TowerFTEChart/TowerFTEChart';
import InfoCards from './InfoCards/InfoCards';
import TileComp from '../ProcureToPayComp/TileComp/TileComp';
import styles from './TransMainDashboard.module.css';
import './TransMainDashboard.css';
import OverallTransitionSummaryCharts from './OverallTransitionSummaryCharts/OverallTransitionSummaryCharts';
import DashboardSection from '../DashboardContainer/DashboardSection';
import OverallBarChart from './OverallBarChart/OverallBarChart';
import HorizontalProgressChart from './HorizontalProgressChart/HorizontalProgressChart';
import ReusableTable from '../ReusableTable/ReusableTable';

import EntityStatusComparisonChart from './EntityStatusComparisonChart/EntityStatusComparisonChart';
import TitleWithDetailedClick from './TitleWithDetailedClick/TitleWithDetailedClick';
import transitions from '@material-ui/core/styles/transitions';



const { API_BASE_URL } = config;

const TransMainDashboard = () => {

  const { showPopup } = usePopupManager();
  const location = useLocation();
  const initialFilters = location.state || {
    inOutData: [],
    locationData: [],
    subDivisionData: [],
    yearData: [],
    quarterData: [],
    towerData: []
  };

  const [filters, setFilters] = useState(initialFilters);
  const [showDashboard, setShowDashboard] = useState(false);
  const [showMainDashboard, setShowMainDashboard] = useState(false);
  const [detailedButtonClick, setDetailedButtonClick] = useState(false);

  const [InOutOptions, setInOutOptions] = useState([]);
  const [LocationOptions, setLocationOptions] = useState([]);
  const [SubDivisionOptions, setSubDivisionOptions] = useState([]);
  const [yearOptions, setYearOptions] = useState([]);
  const [towerOptions, settowerOptions] = useState([]);

  const [actualstatusOptions, setactualstatusOptions] = useState([]);
  const [transitionleadOptions, settransitionleadOptions] = useState([]);


  const [actualstatus, setactualstatus] = useState([]);
  const [transitionlead, settransitionlead] = useState([]);

  const [quarterOptions, setQuarterOptions] = useState([]);
  const [entityOptions, setEntityOptions] = useState([]);
  const [InOut, setInOut] = useState([]);
  const [Location, setLocation] = useState([]);
  const [SubDivision, setSubDivision] = useState([]);
  const [towerselected, settowerselected] = useState([]);
  const [Year, setYear] = useState([]);
  const [Quarter, setQuarter] = useState([]);
  const [entity, setEntity] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedEntityName, setSelectedEntityName] = useState([]);
  const [selectedTowerName, setselectedTowerName] = useState([]);
  const [projectedFTE, setprojectedFTE] = useState(0)
  const [goLiveComplete, setgoLiveComplete] = useState(0)
  const [transitionsInprog, settransitionsInprog] = useState(0)
  const [inFlight, setinFlight] = useState(0)
  const [pipeline, setpipeline] = useState(0)
  const [varinace, setVariance] = useState(0)
  const [totalVaraince, settotalVaraince] = useState(0)
  const [actualFTEs, setactualFTEs] = useState({})
  const [budgetedFTEs, setbudgetedFTEs] = useState()
  const [chartDataOverAll, setchartDataOverAll] = useState({})
  const [towerWiseOverallLabels, settowerWiseOverallLabels] = useState([])
  const [towerWiseOverallActual, settowerWiseOverallActual] = useState({})
  const [towerWiseOverallBudgeted, settowerWiseOverallBudgeted] = useState({})
  const [EntityWiseChart, setEntityWiseChart] = useState()
  const [DetailedTransitionTableData, setDetailedTransitionTableData] = useState([])
  const [sumOfActualTile, setsumOfActualTile] = useState(0)
  const [hasApplied, setHasApplied] = useState(false);
  const [selectedPage, setSelectedPage] = useState();
  const [startPage, setStartPage] = useState(0);
  const [endPage, setEndPage] = useState(100);
  const itemsPerPage = 100;

  const [CSVData, setCSVData] = useState([])


  const tileStyles = {
    tileContainer: {
      width: '155px',
      height: '120px',
      background: 'linear-gradient(135deg, rgb(255 0 73 / 93%) 0%, rgb(213, 149, 181) 100%)',
      borderRadius: '16px',
      border: '1px solid #e11d48', // Changed to match gradient color
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2px 4px',
      fontFamily: 'Arial, sans-serif',
      marginTop: '25px',
      padding: '8px',
      boxSizing: 'border-box',
      color: 'white', // Set default text color to white
      boxShadow: ' rgba(0, 0, 0, 0.4) 4px 4px 8px'
    },
    title: {
      fontSize: '14px',
      fontWeight: '600',
      color: 'white', // White for better contrast
      textAlign: 'center',
      marginBottom: '8px',
      textShadow: '0 1px 2px rgba(0,0,0,0.2)',
      // Adds subtle text shadow for readability
    },
    mainValue: {
      fontSize: '12px',
      fontWeight: '700',
      color: 'white', // White for better contrast
      textAlign: 'center',
      marginBottom: '6px',
      textShadow: '0 2px 4px rgba(0,0,0,0.3)'
    },
    secondaryValue: {
      fontSize: '12px',
      fontWeight: '700',
      color: '#ffffff', // Light yellow for contrast
      textAlign: 'center',
      marginBottom: '4px',
      textShadow: '0 1px 2px rgba(0,0,0,0.2)'
    },
    thirdValue: {
      fontSize: '12px',
      color: '#ffffff', // Light gray
      fontWeight: '700',
      textAlign: 'center',
      // opacity: '0.9'
    }
  };

  const handleInOutChange = (selected) => {
    // setInOut(selected);
    setInOut(selected || []);
    setFilters(prev => ({ ...prev, inOutData: selected }));
  };

  const handleLocationChange = (selected) => {
    // setLocation(selected);
    setLocation(selected || []);
    setFilters(prev => ({ ...prev, locationData: selected }));
  };

  const handleSubDivisionChange = (selected) => {
    // setSubDivision(selected);
    setSubDivision(selected || []);
    setFilters(prev => ({ ...prev, subDivisionData: selected }));
  };


  const handleTowerChange = (selected) => {
    // debugger
    // setSubDivision(selected);
    const selectedArray = selected || [];
    settowerselected(selected || []);
    setFilters(prev => ({ ...prev, towerData: selected }));
    const selectedtowerNames = selectedArray.map(e => e.label);
    setselectedTowerName(selectedtowerNames.join(', '));
  };

  const handleYearChange = (selected) => {
    if (!selected) {
      setYear([]);
      setQuarter([]);
      setFilters(prev => ({ ...prev, yearData: [], quarterData: [] }));
      return;
    }
    const updatedYear = [selected];
    setYear(updatedYear);
    setFilters(prev => ({ ...prev, yearData: updatedYear }));
    setQuarter([]);
    setFilters(prev => ({ ...prev, quarterData: [] }));
  };


  const handleQuarterChange = (selected) => {
    // setQuarter(selected);
    setQuarter(selected || []);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handleactualstatus = (selected) => {
    // debugger
    const selectedArray = selected || [];
    setactualstatus(selectedArray || []);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const handletransitionlead = (selected) => {
    // setQuarter(selected);
     const selectedArray = selected || [];
    settransitionlead(selectedArray || []);
    setFilters(prev => ({ ...prev, quarterData: selected }));
  };

  const fetchInOutOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-in-out`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setInOutOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchLocationOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-location`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setLocationOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchSubDivisionOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-sub-division`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setSubDivisionOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchYearOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-year`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          let YearData = response.data
          // console.log("YearData", YearData)
          // YearData.push(
          //   { label: 'NA', value: 'null' })
          setYearOptions(YearData);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchTowerOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-tower`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          settowerOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchQuerterOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-quarter`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          setQuarterOptions(response.data);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };

  const fetchEntityOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-entity`, {
        headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' },
      });
      const data = response.data || [];
      setEntityOptions(data);
      // if (data.length > 0) {
      //   setEntity([data[0]]);
      //   setSelectedEntityName(data[0].label);
      // }
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };


  const fetchactualstatusOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-actualstatus`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          let YearData = response.data
          // console.log("YearData", YearData)
          // YearData.push(
          //   { label: 'NA', value: 'null' })
          setactualstatusOptions(YearData);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };


  const fetchtransitionleadOptions = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/transition-lead`, {
        headers: {
          // Authorization: `Bearer ${token}`,
          Authorization: 'Basic YWRtaW4xOjEyMw==',
        },
      })
        .then((response) => {
          let YearData = response.data
          // console.log("YearData", YearData)
          // YearData.push(
          //   { label: 'NA', value: 'null' })
          settransitionleadOptions(YearData);
        })
    } catch (error) {
      console.error('Error fetching entity options:', error);
    }
  };


  useEffect(() => {
    fetchInOutOptions();
    fetchLocationOptions();
    fetchSubDivisionOptions();
    fetchYearOptions();
    fetchQuerterOptions();
    fetchEntityOptions();
    fetchTowerOptions();
    fetchactualstatusOptions()
    fetchtransitionleadOptions()
  }, []);


  function calculateVariance(data) {
    const {
      projectedFTE = 0,
      goLiveComplete = 0,
      transitionsInprog = 0,
      inFlight = 0,
      pipeline = 0
    } = data;

    const total = goLiveComplete + transitionsInprog + inFlight + pipeline;

    // Avoid division by zero
    const divisor = projectedFTE !== 0 ? projectedFTE : 1;

    let variancePercent = Number(((projectedFTE - total) / divisor * 100).toFixed(3));
    const totalVaraince = Number((projectedFTE - total).toFixed(3));

    // Set minimum variance to 0
    if (variancePercent < 0) {
      variancePercent = 0;
    }

    return {
      totalVaraince,
      total
    };
  }


  const handleApply = () => {
    // debugger
    const selectedEntity = entity.map(e => e.value);
    const inoutFilterData = InOut.map(e => e.value);
    const locationFilterData = Location.map(e => e.value);
    const subDivisionFilterData = SubDivision.map(e => e.value);
    const yearFilterData = Year.map(e => e.value);
    const quarterData = Quarter.map(e => e.value);
    const subDivison = SubDivision.map(e => e.value);
    const TOWERS = towerselected.map(e => e.value);
    const actualstatusSelect = actualstatus.map(e => e.value);
    const transitionleadSelect = transitionlead.map(e => e.value);


    setIsLoading(true);

    const fetchTransitionFirst = async () => {
      try {
        const response = await axios.post(
          `${API_BASE_URL}/api/Overall-Transition-Status-Dashboard`,
          {
            selectedInout: inoutFilterData,
            selectedLocation: locationFilterData,
            selectedSubDiv: subDivisionFilterData,
            selectedEntity: selectedEntity,
            selectedYear: yearFilterData,
            selectedQuarter: quarterData,
            selectedSubDiv: subDivison,
            selectedTower: TOWERS,
            selectactualstatus: actualstatusSelect,
            selecttransitionlead: transitionleadSelect,
            start: startPage,
            end: endPage,
          },
          {
            headers: { Authorization: 'Basic YWRtaW4xOjEyMw==' }
          }
        );

        const data = response.data;

        setprojectedFTE(data.getTransitionStatusData.projectedFTE);
        setgoLiveComplete(data.getTransitionStatusData.goLiveComplete);
        settransitionsInprog(data.getTransitionStatusData.transitionsInprog);
        setinFlight(data.getTransitionStatusData.inFlight);
        setpipeline(data.getTransitionStatusData.pipeline)
        setchartDataOverAll(data.getQuarterlyTransitionData.chartDataOverAll)
        setDetailedTransitionTableData(data.getDetailedTransitionTableData)
        setCSVData(data.getDetailedTransitionTableData?.csvData)
        const calculatedVariance = calculateVariance(data.getTransitionStatusData);
        settotalVaraince(calculatedVariance?.totalVaraince);
        setVariance(data.getTransitionStatusData.variance)
        // setsumOfActualTile(calculatedVariance?.total)
        setsumOfActualTile(Number(calculatedVariance?.total || 0).toFixed(2))
        setactualFTEs(data.getFTEComparisonData.actualFTEs)
        setbudgetedFTEs(data.getFTEComparisonData.budgetedFTEs)
        settowerWiseOverallLabels(data.getTowerWiseOverallStatus.towerWiseOverallLabels)
        settowerWiseOverallBudgeted(data.getTowerWiseOverallStatus.towerWiseOverallBudgeted)
        settowerWiseOverallActual(data.getTowerWiseOverallStatus.towerWiseOverallActual)
        setEntityWiseChart(data.getDetailedEntityWiseChartData)




      } catch (error) {
        console.error('Error fetching total tiles data:', error);
      }
    };

    Promise.all([
      fetchTransitionFirst(),

    ]).then(() => {
      setShowDashboard(true);
      setShowMainDashboard(true);
      setDetailedButtonClick(false);
      setIsLoading(false);
    });

  };


  const handleReset = () => {
    setInOut([]);
    setLocation([]);
    setSubDivision([]);
    setYear([]);
    setQuarter([]);
    setFilters({
      inOutData: [],
      locationData: [],
      subDivisionData: [],
      yearData: [],
      quarterData: [],
      towerData: []
    });
    setEntity([])
    settowerselected([])
    setShowDashboard(false);
    setShowMainDashboard(false);
    setDetailedButtonClick(false);
    setSelectedEntityName([])
    setselectedTowerName([])
  };


  const handleEntity = (selected) => {
    const selectedArray = selected || [];
    setEntity(selectedArray);
    // const selectedEntityNames = selectedArray.map(e => e.label);
    // setSelectedEntityName(selectedEntityNames.join(', '));
    const selectedEntityNames = selectedArray.map(e => e.label);
    setSelectedEntityName(selectedEntityNames.join(', '));

    const selectedEntityValues = selectedArray.map(e => e.value);
    const inoutFilterData = InOut.map(e => e.value);
    const locationFilterData = Location.map(e => e.value);
    const subDivisionFilterData = SubDivision.map(e => e.value);
    const yearFilterData = Year.map(e => e.value);
    const quarterData = Quarter.map(e => e.value);

    // fetchTransitionOverallWithEntity(
    //   selectedEntityValues,
    //   inoutFilterData,
    //   locationFilterData,
    //   subDivisionFilterData,
    //   yearFilterData,
    //   quarterData
    // );
  };




  const customStylesMultiSelect = {
    control: (provided) => ({
      ...provided,
      minHeight: '40px',
      flexWrap: 'wrap',
    }),
    valueContainer: (provided) => ({
      ...provided,
      maxHeight: '100px',
      overflowY: 'auto',
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflow: 'visible',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      overflowX: 'auto',
      whiteSpace: 'nowrap',
    }),
    option: (provided) => ({
      ...provided,
      padding: '8px 12px',
    }),
  };

  const labelsOverAll =
    [
      "Go-live Completed",
      "Transition in Progress",
      "Inflight",
      "Pipeline",
    ]



  const paidOnTimeGradient = 'linear-gradient(135deg, #F43F5E 0%, #DB2777 100%)';
  const blueGradient = 'linear-gradient(135deg, #3B82F6 0%, #4F46E5 100%)';
  const indigoGradient = 'linear-gradient(135deg, #6366F1 0%, #7C3AED 100%)';
  const purpleGradient = 'linear-gradient(135deg, #8B5CF6 0%, #C026D3 100%)';
  const emeraldGradient = 'linear-gradient(135deg, #10B981 0%, #0D9488 100%)';
  const varinceGradient = 'linear-gradient(135deg, #EC4899 0%, #d595b5ff 100%)';



  const columns = [
    { header: "Legal_Entity", accessor: "Legal_Entity" },
    { header: "Tower", accessor: "Tower" },
    { header: "Work Area", accessor: "Work_Area" },
    { header: "Actual_Status", accessor: "Actual_Status" },
    { header: "Budgeted_FTE_Nos", accessor: "Budgeted_FTE_Nos" },
    { header: "Budget_GO_live_Month", accessor: "Budget_GO_live_Month" },
    { header: "Actual_FTE_Nos", accessor: "Actual_FTE_Nos" },
    { header: "Billing_GO_live_Month", accessor: "Billing_GO_live_Month" },
    { header: "Variance", accessor: "Variance" }
  ];



  const columnsDetailed = [
    { header: "Legal_Entity", accessor: "Legal_Entity" },
    { header: "Tower", accessor: "Tower" },
    { header: "Work Area", accessor: "Work_Area" },
    { header: "Actual_Status", accessor: "Actual_Status" },
    { header: "Budgeted_FTE_Nos", accessor: "Budgeted_FTE_Nos" },
    { header: "Budget_GO_live_Month", accessor: "Budget_GO_live_Month" },
    { header: "Actual_FTE_Nos", accessor: "Actual_FTE_Nos" },
    { header: "Billing_GO_live_Month", accessor: "Billing_GO_live_Month" },
    { header: "Variance", accessor: "Varince" }
  ];

  const handlePageChange = (page) => {
    setHasApplied(true)
    setSelectedPage(page);
    let endPageVal = page * 100
    let startPageVal = endPageVal - 99

    setStartPage(startPageVal)
    setEndPage(endPageVal)
    // console.log(`Selected page: ${page}`);

  };

  const [dataLoading, setdataLoading] = useState(false);

  const handleCSVDownload = () => {
    const csvHeader = columns.map(col => col.header).join(',');

    const csvRows = CSVData.map(row =>
      columns
        .map(col => {
          const value = row[col.accessor];

          // Convert to string safely (handles null, undefined, numbers)
          const stringValue =
            value === null || value === undefined
              ? ''
              : String(value);

          // Escape double quotes
          return `"${stringValue.replace(/"/g, '""')}"`;
        })
        .join(',')
    );

    const csvContent = [csvHeader, ...csvRows].join('\n');

    const blob = new Blob([csvContent], {
      type: 'text/csv;charset=utf-8;',
    });

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'Transition_Overall_status.csv';
    link.click();
  };


  useEffect(() => {
    if (hasApplied) {
      handleApply();
    }
  }, [selectedPage, hasApplied]);



  const labelsDetailedEntityWiseChart = [
    "Pre Transition",
    "Planning",
    "Execution",
    "Parallel Run",
    "Go-live & Stabilization",
    "To be explored",
    "Other Status-Grand Total",
    "Dropped",
    "On Hold",
    "Dropped & On Hold Grand Total"
  ];



  const handleDetailClick = () => {
    setDetailedButtonClick(true);
    setShowMainDashboard(false);
  }

  const handleMainPageClick = () => {
    setDetailedButtonClick(false);
    setShowMainDashboard(true);
  }

  return (
    <>
      <div className={styles.filter_panel_container}>
        <div className={styles.filter_panel_row}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>IN/OUT</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={InOut}
                onChange={handleInOutChange}
                options={InOutOptions}
                closeMenuOnSelect={false}
                isMulti
                isSearchable={true}
                placeholder="Select IN/OUT"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Location</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Location}
                onChange={handleLocationChange}
                options={LocationOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Location"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Legal Entity</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={entity}
                placeholder={<div className="select-placeholder-text">Select Legal Entity</div>}
                onChange={handleEntity}
                options={entityOptions}
                isMulti
                isSearchable={true}
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Sub-Division</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={SubDivision}
                onChange={handleSubDivisionChange}
                options={SubDivisionOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Sub-Division"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
        </div>
        <div className={styles.filter_panel_row} style={{ paddingTop: "10px" }}>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Tower</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={towerselected}
                onChange={handleTowerChange}
                options={towerOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Tower"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Financial Year</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Year}
                onChange={handleYearChange}
                options={yearOptions}
                isSearchable={true}
                placeholder="Financial Year"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>
          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Quarter</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={Quarter}
                onChange={(selected) => {
                  if (Year.length === 0) {
                    showPopup({
                      type: MESSAGE_TYPE.INFORMATION,
                      contextText: MESSAGE_TYPE.INFORMATION,
                      info: "Please select Financial Year first before selecting Quarter.",
                    });
                    return;
                  }
                  handleQuarterChange(selected);
                }}
                options={quarterOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Quarter"
                closeMenuOnSelect={false}
                styles={customStylesMultiSelect}
                isDisabled={Year.length === 0}
              />
            </div>
          </div>



          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Actual Status</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={actualstatus}
                onChange={handleactualstatus}
                options={actualstatusOptions}
                isSearchable={true}
                isMulti
                placeholder="actual status"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>


          <div className={styles.filter_panel_col}>
            <label className={styles.filter_label}>Transition Lead</label>
            <div className={styles.filter_select_wrapper}>
              <Select
                value={transitionlead}
                onChange={handletransitionlead}
                options={transitionleadOptions}
                isSearchable={true}
                isMulti
                placeholder="Transition Lead"
                styles={customStylesMultiSelect}
              />
            </div>
          </div>












          <div className={styles.filter_panel_col}>
            <div className={styles.filter_select_wrapper}>
              <div className="filter-panel-col">
                <button onClick={handleApply} className="btn apply-btn">
                  Apply
                </button>
                <button onClick={handleReset} className="btn reset-btn">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div className="text-center">
            <div className="spinner-border text-primary mb-3" role="status"></div>
            <p className="mb-3" style={{ fontSize: "18px", fontWeight: "bold", color: "#0067ac" }}>Loading...</p>

          </div>
        </div>
      )}
      {showDashboard && (
        <>
          <div>
            <div className="row mb-3">
              <div className="col-md-2" style={{ paddingTop: "30px" }}>
                <TileComp
                  title="Projected FTEs"
                  number={projectedFTE}
                  gradient={paidOnTimeGradient}
                  popupContent="This Metric Mannual CSV Data."
                  showDownload={false}
                />
              </div>
              <div className="col-md-4">
                {/* <div className="border rounded p-2 h-100 shadow-sm"> */}
                <div className=" h-200 shadow-sm" style={{ background: "#ddd", borderRadius: "14px" }}>
                  <p className="text-center fw-bold mb-2">
                    Reported to Finance
                  </p>
                  <div className="row">
                    <div className="col-md-6">
                      <TileComp
                        title="Go-Live Completed"
                        number={goLiveComplete}
                        gradient={blueGradient}
                        popupContent="This Metric Mannual CSV Data."
                        showDownload={false}
                      />
                    </div>
                    <div className="col-md-6">
                      <TileComp
                        title="Transition in Progress"
                        number={transitionsInprog}
                        gradient={indigoGradient}
                        popupContent="This Metric Mannual CSV Data."
                        showDownload={false}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-2">
                <div className="row" style={{ marginLeft: '0.2px' }}>
                  <div className="row" style={{ background: "#ddd", borderRadius: "14px", width: '185px', marginLeft: '0.1px', padding: '2px' }}>
                    <p className="text-center mb-2" style={{ fontSize: '12px' }}>
                      <b>
                        Approval Received
                      </b>
                    </p>

                    <TileComp
                      title="Inflight"
                      number={inFlight}
                      gradient={purpleGradient}
                      popupContent="This Metric Mannual CSV Data."
                      showDownload={false}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-2" style={{ paddingTop: "30px" }}>
                <TileComp
                  title="Pipeline"
                  number={pipeline}
                  gradient={emeraldGradient}
                  popupContent="This Metric Mannual CSV Data."
                  showDownload={false}
                />
              </div>
              <div className="col-md-2" style={{ paddingTop: "5px" }}>
                <div style={tileStyles.tileContainer}>
                  <div style={tileStyles.title}>Variance</div>

                  <div>
                    <div style={tileStyles.mainValue}>Variance {totalVaraince}</div>
                    <div style={tileStyles.secondaryValue}>Variance Per {varinace}%</div>
                    <div style={tileStyles.thirdValue}>Actual Total {sumOfActualTile}</div>
                  </div>
                </div>
              </div>
            </div>


            {showMainDashboard && (
              <div>
                <TitleWithDetailedClick
                  // title="Overall Transition Summary"
                  title={selectedEntityName && selectedTowerName ? `${selectedEntityName}  ${selectedTowerName} Transition Summary` : " Overall  Transition Summary"}
                  handleDetailClick={handleDetailClick}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Transition Summary" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters}>
                      <OverallTransitionSummaryCharts
                        labels={labelsOverAll}
                        chartData={chartDataOverAll}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-3">
                    <DashboardSection title="Budgeted vs Actual FTE by Phase" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                      <div>
                        <HorizontalProgressChart
                          labels={labelsDetailedEntityWiseChart}
                          actualFTEs={actualFTEs}
                          budgetedFTEs={budgetedFTEs}
                          heightValues={250}
                        />
                      </div>
                    </DashboardSection>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12">
                    <DashboardSection title="Transition Inventory Details Main" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="">
                      <ReusableTable
                        data={DetailedTransitionTableData?.dataDetailed} columns={columnsDetailed} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={DetailedTransitionTableData?.totalCount
                        } handleCSVDownload={handleCSVDownload} dataLoading={dataLoading} showPagination={true}
                      />


                    </DashboardSection>
                  </div>
                </div>
              </div>
            )}
            {/* after click on detailed page */}
            {detailedButtonClick && (
              <div>
                <TitleWithDetailedClick
                  title="Detailed View"
                  handleBackClick={handleMainPageClick}
                  showBackButton={true}
                  showDetailedButton={false}
                />
                <div className="row">
                  <div className="col-12 col-lg-6 mb-1">
                    <DashboardSection title="Entity wise Drilldown" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="/Transition-Page/Overall-Transition-Summary" detailState={filters}>

                      <EntityStatusComparisonChart
                        labels={EntityWiseChart?.labelsDetailedEntityWiseChart}
                        actualFTEs={EntityWiseChart?.entityActualFTEs}
                        budgetedFTEs={EntityWiseChart?.entityBudgetedFTEs}
                        title={selectedEntityName}
                      />
                    </DashboardSection>
                  </div>
                  <div className="col-12 col-lg-6 mb-1">
                    <DashboardSection title="Tower Wise Overall Status" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="/Transition-Page/Overall-Hiring-Summary" detailState={filters}>
                      <div>
                        <HorizontalProgressChart
                          labels={towerWiseOverallLabels}
                          actualFTEs={towerWiseOverallActual}
                          budgetedFTEs={towerWiseOverallBudgeted}
                          heightValues={260}
                        />
                      </div>
                    </DashboardSection>
                  </div>
                </div>
                <div className="row">
                  <div className="col-12 col-lg-12 mb-3">
                    <DashboardSection title="Transition Inventory Details Detail" infoIcondata="MANUAL CSV Data" disableDetailView={true} detailPath="">
                      <ReusableTable
                        data={DetailedTransitionTableData?.dataDetailed} columns={columnsDetailed} itemsPerPage={itemsPerPage} onPageChange={handlePageChange} isCustomOpen={true} totalRecords={DetailedTransitionTableData?.totalCount
                        } handleCSVDownload={handleCSVDownload} dataLoading={dataLoading} showPagination={true}
                      />


                    </DashboardSection>
                  </div>

                </div>
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default TransMainDashboard;
